import { api } from "./api";

/**
 * 站点文案的模块级缓存：
 * 「页面文案 / 动态 / 招聘」三个菜单共享一份数据，
 * 切换菜单不再重新请求、不闪「加载中」。保存后更新缓存。
 */

export type DocKey = "site_data" | "i18n";
export type ContentRow = { key: DocKey; value: any; updated_at: string };
export type ContentDocs = { docs: Record<DocKey, any>; updatedAt: Record<DocKey, string> };

let cache: ContentDocs | null = null;
let inflight: Promise<ContentDocs> | null = null;

export async function loadContent(force = false): Promise<ContentDocs> {
  if (cache && !force) return cache;
  if (!inflight || force) {
    inflight = api.get<ContentRow[]>("/api/admin/content").then((rows) => {
      const docs: any = {};
      const updatedAt: any = {};
      for (const r of rows) { docs[r.key] = r.value; updatedAt[r.key] = r.updated_at; }
      cache = { docs, updatedAt };
      return cache;
    }).finally(() => { inflight = null; });
  }
  return inflight;
}

export function peekContent(): ContentDocs | null {
  return cache;
}

export async function saveDoc(key: DocKey, value: any): Promise<ContentRow> {
  const row = await api.put<ContentRow>(`/api/admin/content/${key}`, { value });
  if (cache) {
    cache = {
      docs: { ...cache.docs, [key]: value },
      updatedAt: { ...cache.updatedAt, [key]: row.updated_at },
    };
  }
  return row;
}

/** 编辑中（未保存）的草稿同步进缓存，菜单切换后回来不丢 */
export function stashDraft(key: DocKey, value: any) {
  if (cache) cache = { ...cache, docs: { ...cache.docs, [key]: value } };
}
